import React from "react";
import { ResponsiveBar} from "@nivo/bar"
import { useTheme } from "@mui/material";

const GraphChart = ({ dynamicWidth, nivoData, nivoKeys, groupColors }) => {
  const graphFontColor = useTheme().palette.mode === "dark" ? "#FFFFFF" : "#000000"; 
  // nivo plot theme
  const nivoTheme = {
    text: {
      fontFamily: "Inter",
      fontSize: 12,
      fill: graphFontColor,
    },
    axis: {
      ticks: {text: { fill: graphFontColor } },
      legend: { text: { fill: graphFontColor } },
    },
    legends: {
      text: { fill: graphFontColor },
    },
    labels: {
      text: { fill: graphFontColor },
    }
  }

  // format ticks to Millions
  const formatMillions = (v) => `$${(v / 1e6).toFixed(1)}M`;
  const formatToM = (v) => `${(Number(v) / 1e6).toFixed(1)}M`;

  // sum for each category
  const TotalsLayer = ({ bars }) => {
    // bars = all stacked segments (rects) Nivo is drawing
    // group bars by category (indexValue)
    const byIndex = new Map();

    for (const b of bars) {
      const key = b.data.indexValue; // category label (your indexBy)
      if (!byIndex.has(key)) byIndex.set(key, []);
      byIndex.get(key).push(b);
    }

    return (
      <g>
        {[...byIndex.entries()].map(([indexValue, groupBars]) => {
          // total = sum of all segment values in this category
          const total = groupBars.reduce((sum, b) => sum + (Number(b.data.value) || 0), 0);

          // find the top-most segment (smallest y) to position the label above the stack
          const topBar = groupBars.reduce((best, b) => (b.y < best.y ? b : best), groupBars[0]);

          const x = topBar.x + topBar.width / 2;
          const y = topBar.y - 6; // a bit above the stack

          return (
            <text
              key={indexValue}
              x={x}
              y={y}
              textAnchor="middle"
              dominantBaseline="central"
              fill={graphFontColor}
              style={{ fontSize: 12 }}
            >
              {formatToM(total)}
            </text>
          );
        })}
      </g>
    );
  };

  return (
    <div style={{ width: dynamicWidth, height: "485px" }}>
      <ResponsiveBar
        data={nivoData}
        keys={nivoKeys}
        indexBy="x"
        groupMode="stacked"
        margin={{ top: 100, right: 20, bottom: 30, left: 60 }}
        axisLeft={{ legend: "Amount (USD)", legendPosition: "middle", legendOffset: -55, format: formatMillions }}
        enableLabel={true}
        label={({ value }) => formatToM(value)}
        colors={({ id }) => {
          return groupColors[id] || "#888888";
        }}
        theme={nivoTheme}
        enableGridX={false}
        enableGridY={false}
        layers={["grid", "axes", "bars", TotalsLayer, "markers", "legends"]}
        legends={[
          {
            anchor: "top",
            direction: "row",
            justify: false,
            translateX: 0,   
            translateY: -55,
            itemsSpacing: 7,
            itemWidth: 150,
            itemHeight: 18,
            itemDirection: "left-to-right",
            symbolSize: 12,
            symbolShape: "square",
          },
        ]}
        axisBottom={{
          tickRotation: 0,
          format: (v) => String(v).replace(" ", "\n"),
        }}
        padding={0.4}
      />
    </div>
  );
}

export default GraphChart;
